import { render, staticRenderFns } from "./u-btn-arrow-outlined-tile.vue?vue&type=template&id=65d6ab1a&scoped=true&"
import script from "./u-btn-arrow-outlined-tile.vue?vue&type=script&lang=js&"
export * from "./u-btn-arrow-outlined-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d6ab1a",
  null
  
)

export default component.exports